window.addEventListener("load", function() {
  $(".rate").on("mouseenter", event => {
    $(".rates").addClass("rates--black");
  });

  $(".rate").on("mouseleave", event => {
    $(".rates").removeClass("rates--black");
  });
});
